import React from 'react';
import { Link } from 'react-router-dom';

function Logo({ isHome, mode, className = '', style = {} }) {
	return (
		<Link to="/" data-testid="logo-container">
			<div className={`logo-wrapper ${className} p-3 pl-5`} style={style}>
				<div
					className={`logo-container ${mode} ${isHome === true ? '' : 'm-0'}`}
				/>
			</div>
		</Link>
	);
}

export default Logo;
